import { CartItemViewModel, CartPromotionViewModel, LineItemViewModel, PromotionOfferType } from '@/types/api'

import { CartActionPlacement } from '@/features/webengage/types'

import { EventsCartItemData, SupportedEvents } from './types'

export const calculateCartTotalPrice = (items: CartItemViewModel[]) => {
    const totalValue = items.reduce((acc, item) => {
        const salesPrice = item.salesPrice || 0
        const quantity = item.qty || 1
        const price = item.pricingGift ? 0 : salesPrice * quantity

        return acc + price
    }, 0)

    return totalValue
}

export const calculatePurchaseTotalValue = (items: LineItemViewModel[]) => {
    const totalValue = items.reduce((acc, item) => {
        const salesPrice = item.price || 0
        const quantity = item.quantity || 1
        const price = item.hasPricingGift ? 0 : salesPrice * quantity

        return acc + price
    }, 0)

    return totalValue
}

export const generateEventsCouponData = (
    items: CartItemViewModel[],
    promotion: CartPromotionViewModel | null,
    khanoumiOrderShippingCost: number | null
) => {
    let coupon_amount: number | null = null
    let coupon: string | null = null

    switch (promotion?.offerType) {
        case PromotionOfferType.Gift: {
            const giftItem = items?.find((item) => item.promotionOffer)
            coupon_amount = giftItem?.salesPrice || null

            break
        }
        case PromotionOfferType.FixInPurchasePrice:
        case PromotionOfferType.PercentageInPurchasePrice: {
            coupon_amount = promotion.discount || null

            break
        }
        case PromotionOfferType.FreeShipping: {
            coupon_amount = khanoumiOrderShippingCost ?? null

            break
        }
    }

    coupon = promotion ? `${promotion.offerType}-${promotion.title}` : null

    return { coupon, coupon_amount }
}

export const generateEvnetsItemsData = (
    items: CartItemViewModel[],
    placement?: CartActionPlacement,
    index?: number
): EventsCartItemData[] => {
    const generatedItemsView = items.map<EventsCartItemData>((item) => {
        const basePrice = item.basePrice || 0
        const salesPrice = item.salesPrice || 0
        const quantity = item.qty || 1
        const price = item.pricingGift ? 0 : salesPrice
        const discount = item.pricingGift ? basePrice : basePrice - salesPrice

        const generatedData: EventsCartItemData = {
            item_id: item.atpId || null,
            item_name: item.productName || null,
            coupon: item.pricingGift ? 'pricinggift' : null,
            item_brand: item.brandName || null,
            item_category: item.categoryLevel1 || null,
            item_category2: item.categoryLevel2 || null,
            item_category3: item.categoryLevel3 || null,
            item_category4: null,
            item_category5: null,
            item_variant: item.colorName || null,
            price,
            discount,
            quantity,
            ship_by_seller: item.shipBySeller || false,
        }

        if (typeof index !== 'undefined') generatedData.index = index

        if (placement) {
            generatedData.item_list_id = placement
            generatedData.item_list_name = placement
        }

        return generatedData
    })

    return generatedItemsView
}

export const findCartsDiff = (
    type: SupportedEvents.add_to_cart | SupportedEvents.remove_from_cart,
    prevItems: CartItemViewModel[],
    curItems: CartItemViewModel[]
) => {
    const diffItems: Array<CartItemViewModel> = []

    const bigger_arr = type === SupportedEvents.add_to_cart ? curItems : prevItems
    const smaller_arr = type === SupportedEvents.add_to_cart ? prevItems : curItems

    bigger_arr.forEach((item) => {
        const itemInPrevCart = smaller_arr.find(({ id }) => id === item.id)

        if (itemInPrevCart) {
            const changedQty = Math.abs((item.qty ?? 0) - (itemInPrevCart.qty ?? 0))
            changedQty !== 0 && diffItems.push({ ...item, qty: changedQty })
        } else {
            diffItems.push(item)
        }
    })

    return diffItems
}
